import LoadingState from '../../../values/loading-state-enum'
import {type OTAssetRow} from '../../../pages/ot-inventory/contexts/types/ot-asset-row-types'
import {type OTAssetRowValidation} from '../../../pages/ot-inventory/components/asset-upload/types/validation-types'
import {
    COLUMN_MAPPING_DEFAULT_VALUE,
    type ColumnsMapping,
} from '../../../pages/ot-inventory/types/asset-upload-types'
import type {OTAsset} from '@/api/ot-inventory/types/ot-inventory.types'

// Re-export for backward compatibility

/**
 * Enum keys for GET/POST for asset list.
 */
export enum OTAssetKeyEnum {
    SYSTEM = 'systemID',
    NAME = 'name',
}

interface DataReview {
    validationResult: OTAssetRowValidation[]
    duplicateAssetsInFile: Record<string, string[]>
    duplicateAssetsInDb: Record<string, string[]>
}

interface ColumnMappingStep {
    columnsMapping: ColumnsMapping
}

interface BulkUpload {
    assets: OTAssetRow[]
    dataReview: DataReview
    columnMapping: ColumnMappingStep
}

export interface OTAssetStateReduxState {
    loadingState: LoadingState
    locationID: string
    assets: OTAsset[]
    openedModal: boolean
    selectedModalAsset?: OTAsset
    deleteAssetIsLoading: boolean
    deleteAssetError: string
    cortexSuggestion: Partial<OTAssetRow[]>
    bulkUpload: BulkUpload
}

export const DEFAULT_OTASSETS_STATE: OTAssetStateReduxState = {
    loadingState: LoadingState.NotPopulated,
    locationID: '',
    assets: [],
    openedModal: false,
    deleteAssetIsLoading: false,
    deleteAssetError: '',
    cortexSuggestion: [],
    bulkUpload: {
        assets: [],
        columnMapping: {
            columnsMapping: COLUMN_MAPPING_DEFAULT_VALUE,
        },
        dataReview: {
            validationResult: [],
            duplicateAssetsInFile: {},
            duplicateAssetsInDb: {},
        },
    },
}

export interface UpdateBulkUploadAssetPayload {
    rowIndex: number
    columnId: string
    value: string
}
